import { normalize } from 'normalizr';
import { query, mutation } from '@/dex-shared/helpers/graphql';
import { institution } from '@/dex-shared/helpers/normalizr_schema';

export default {
  async PULL_INSTITUTIONS(
    { commit }: any,
    {
      currentPage,
      resultsPerPage,
    }: { currentPage: number; resultsPerPage: number },
  ) {
    currentPage = currentPage || 0;
    resultsPerPage = resultsPerPage || 50;
    const offset = resultsPerPage * currentPage;
    const response = await query(
      `query pullInstitutions($resultsPerPage: Int, $offset: Int) {
        allInstitutions(first: $resultsPerPage, offset: $offset, orderBy: TITLE_ASC) {
          nodes {
            id
            title
          }
        }
      }`,
      {
        resultsPerPage,
        offset,
      },
    );
    const normalizedResponse = normalize(response.data.allInstitutions.nodes, [
      institution,
    ]);
    commit('CLEAN_STATE', 'institutions');
    commit('SET_NORMALIZED_DATA', normalizedResponse.entities);
  },
  async REMOVE_INSTITUTION({ commit }: any, institutionId: number) {
    const response = await mutation(
      `mutation dexAdminDeleteInstitutionById($institutionId: Int!) {
      deleteInstitutionById(input: {
        id: $institutionId
      }) {
        institution {
          id
        }
      }
    }`,
      { institutionId },
    );
    if (!response.errors) {
      commit('DELETE_ENTITY', {
        entity: 'institutions',
        id: institutionId,
      });
    }
  },
};
